// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accent-color: #28a745;
  --danger-color: #dc3545;
  --text-color-dark: #343a40;
  --text-color-medium: #6c757d;
  --text-color-light: #f8f9fa;
  --card-bg: #ffffff;
  --container-bg: #f8f9fa;
  --border-color: #e9ecef;
  --shadow-light: rgba(0, 0, 0, 0.08);
  --shadow-medium: rgba(0, 0, 0, 0.15);
  --spacing-unit: 0.75rem;
}

.exp-main-div-header {
  position: relative;
  z-index: 1;
}
.exp-main-div-header .filter-group label {
  display: block;
  margin-bottom: 8px;
}

.expense-container {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--spacing-unit);
  padding: calc(var(--spacing-unit) * 2);
  background: var(--container-bg);
}

.expenses-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.expenses-table thead {
  background-color: #f1f5f9;
}
.expenses-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.expenses-table tbody tr {
  transition: background-color 0.2s ease;
}
.expenses-table tbody tr:hover {
  background-color: #f9fafb;
}
.expenses-table tbody tr td {
  padding: 0.9rem 1rem;
}
.expenses-table tbody tr td:last-child {
  white-space: nowrap;
}
.expenses-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #17a2b8;
  color: white;
}
.expenses-table tbody tr td:last-child button:last-child {
  background-color: #dc2626;
}
.expenses-table tbody tr td:last-child button:hover {
  opacity: 0.9;
}

.expense-card-main {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: calc(var(--spacing-unit) * 2);
  transition: all 0.2s ease-in-out;
  position: relative;
}
.expense-card-main .expense-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 0.5rem;
  padding-bottom: var(--spacing-unit);
  border-bottom: 1px solid var(--border-color);
}
.expense-card-main .expense-header .expense-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-color-dark);
  margin: 0;
}
.expense-card-main .expense-header .expense-actions {
  display: flex;
  gap: 0.75rem;
}
.expense-card-main .expense-header .expense-actions .action-button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.expense-card-main .expense-header .expense-actions .action-button:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.expense-card-main .expense-details-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem 1.5rem;
  margin-bottom: calc(var(--spacing-unit) * 1.5);
}
.expense-card-main .expense-details-grid .exp-detail-item {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: var(--text-color-medium);
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-icon {
  color: var(--primary-color);
  font-size: 1.15rem;
  margin-right: 0.5rem;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-label {
  font-weight: 600;
  color: var(--text-color-dark);
  margin-right: 0.25rem;
  width: 100px;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value {
  font-weight: 500;
  color: var(--text-color-dark);
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value.amount {
  color: var(--accent-color);
  font-weight: 700;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value.expense-type-tag {
  background-color: var(--primary-color);
  color: var(--text-color-light);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.85em;
  font-weight: 600;
}
.expense-card-main .expense-details-grid .exp-detail-item .detail-value.expense-court-ref {
  background-color: #f0f0f0;
  color: var(--text-color-dark);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.85em;
  font-weight: 500;
  border: 1px solid #d4d4d4;
}
.expense-card-main .expense-description {
  font-size: 0.9rem;
  color: var(--text-color-medium);
  line-height: 1.6;
  margin-bottom: var(--spacing-unit);
}
.expense-card-main .expense-description p {
  margin: 0;
}
.expense-card-main .expense-description p strong {
  color: var(--text-color-dark);
}
.expense-card-main .expense-document {
  margin-top: calc(var(--spacing-unit) * 0.5);
}
.expense-card-main .expense-document a {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
}
.expense-card-main .expense-document a:hover {
  text-decoration: underline;
}

.no-expenses {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

.error-msg {
  text-align: center;
  font-size: 0.95rem;
  color: var(--danger-color);
  background: #ffecec;
  padding: var(--spacing-unit) calc(var(--spacing-unit) * 1.5);
  border-radius: 0.375rem;
  border: 1px solid #ffccca;
  margin-bottom: var(--spacing-unit);
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  gap: 10px;
}
.pagination-controls button {
  padding: 6px 12px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
}
.pagination-controls button:disabled {
  background: var(--primary-color);
  cursor: not-allowed;
  opacity: 0.6;
}

.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.pagination-settings #expensePerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #expensePerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #expensePerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #expensePerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@media (max-width: 768px) {
  .expense-container {
    padding: var(--spacing-unit);
    gap: var(--spacing-unit);
  }
  .expense-container .expense-card-main {
    padding: calc(var(--spacing-unit) * 1.5);
  }
  .expense-container .expense-card-main .expense-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: var(--spacing-unit);
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-courtRef-tag {
    background-color: #f0f0f0;
    color: var(--text-color-medium);
    padding: 0.2em 0.6em;
    border-radius: 0.25em;
    font-size: 0.8em;
    font-weight: 500;
    border: 1px solid #d4d4d4;
    display: inline-block;
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-title {
    font-size: 1.3rem;
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-actions {
    align-self: flex-end;
    margin-top: 0.5rem;
  }
  .expense-container .expense-card-main .expense-details-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: var(--spacing-unit);
  }
  .expense-container .expense-card-main .expense-description,
  .expense-container .expense-card-main .expense-document {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .expense-container {
    padding: calc(var(--spacing-unit) * 0.5);
  }
  .expense-container .expense-card-main {
    padding: var(--spacing-unit);
  }
  .expense-container .expense-card-main .expense-header .exp-main-detail .expense-title {
    font-size: 1.1rem;
  }
  .expense-container .expense-card-main .expense-details-grid .exp-detail-item {
    font-size: 0.85rem;
  }
  .expense-container .expense-card-main .expense-details-grid .exp-detail-item .detail-icon {
    font-size: 1rem;
  }
}
.exp-courtRef-tag {
  margin-bottom: 1rem;
  background-color: #f0f0f0;
  color: var(--text-color-medium);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.8em;
  font-weight: 500;
  border: 1px solid #d4d4d4;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/pages/Expenses/Expense.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oCAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF;AAAE;EACE,cAAA;EACA,kBAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,2DAAA;EACA,wBAAA;EACA,sCAAA;EACA,+BAAA;AACF;;AAOA;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAJF;AAME;EACM,yBAAA;AAJR;AAMI;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AAJN;AAUI;EACE,sCAAA;AARN;AAUM;EACE,yBAAA;AARR;AAWM;EACE,oBAAA;AATR;AAaM;EACE,mBAAA;AAXR;AAaQ;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAXV;AAaU;EACE,yBAAA;AAXZ;AAcU;EACE,YAAA;AAZZ;;AAmBA;EACE,0BAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,gCAAA;EACA,kBAAA;AAhBF;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,4CAAA;AAfJ;AAiBI;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;AAfN;AAkBI;EACE,aAAA;EACA,YAAA;AAhBN;AAkBM;EAWI,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA1BV;AA2BU;EACE,+BAAA;EACA,YAAA;AAzBZ;AAgCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8CAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;AA9BN;AAgCM;EACE,2BAAA;EACA,kBAAA;EACA,oBAAA;AA9BR;AAiCM;EACE,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,YAAA;AA/BR;AAkCM;EACE,gBAAA;EACA,6BAAA;AAhCR;AAkCQ;EACE,0BAAA;EACA,gBAAA;AAhCV;AAmCQ;EACE,sCAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAjCV;AAoCQ;EACE,yBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAlCV;AAwCE;EACE,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,kCAAA;AAtCJ;AAwCI;EACE,SAAA;AAtCN;AAwCM;EACE,6BAAA;AAtCR;AA2CE;EACE,2CAAA;AAzCJ;AA2CI;EACE,2BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAzCN;AA2CM;EACE,0BAAA;AAzCR;;AA+CA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA5CF;;AA+CA;EACE,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,4DAAA;EACA,uBAAA;EACA,yBAAA;EACA,kCAAA;AA5CF;;AAgDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;AA7CF;AAgDE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AA9CJ;AAiDI;EACE,gCAAA;EACA,mBAAA;EACA,YAAA;AA/CN;;AAuDA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AApDF;AAuDE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArDJ;AAyDE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AA7DJ;AAgEI;EACE,yBAAA;AA9DN;AAkEI;EACE,wDAAA;EACA,uBAAA;AAhEN;AAoEI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAlEN;;AAsEA;;EAEE,wBAAA;EACA,SAAA;AAnEF;;AAuEA;EACE;IACE,4BAAA;IACA,wBAAA;EApEF;EAsEE;IACE,wCAAA;EApEJ;EAsEI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,kCAAA;EApEN;EAyEQ;IACE,yBAAA;IACA,+BAAA;IACA,oBAAA;IACA,qBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,qBAAA;EAvEV;EA0EQ;IACE,iBAAA;EAxEV;EA2EQ;IACE,oBAAA;IACA,kBAAA;EAzEV;EAgFI;IACE,0BAAA;IACA,WAAA;IACA,kCAAA;EA9EN;EAiFI;;IAEE,kBAAA;EA/EN;AACF;AAoFA;EACE;IACE,wCAAA;EAlFF;EAoFE;IACE,4BAAA;EAlFJ;EAsFQ;IACE,iBAAA;EApFV;EA2FM;IACE,kBAAA;EAzFR;EA2FQ;IACE,eAAA;EAzFV;AACF;AA+FG;EACC,mBAAA;EACQ,yBAAA;EACA,+BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA7FZ","sourcesContent":[":root {\r\n  --accent-color: #28a745;\r\n  --danger-color: #dc3545;\r\n  --text-color-dark: #343a40;\r\n  --text-color-medium: #6c757d;\r\n  --text-color-light: #f8f9fa;\r\n  --card-bg: #ffffff;\r\n  --container-bg: #f8f9fa;\r\n  --border-color: #e9ecef;\r\n  --shadow-light: rgba(0, 0, 0, 0.08);\r\n  --shadow-medium: rgba(0, 0, 0, 0.15);\r\n  --spacing-unit: 0.75rem;\r\n}\r\n\r\n.exp-main-div-header {\r\n  position: relative;\r\n  z-index: 1;\r\n  .filter-group label{\r\n    display: block;\r\n    margin-bottom: 8px;\r\n  }\r\n}\r\n\r\n.expense-container {\r\n  margin-top: 1rem;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\r\n  gap: var(--spacing-unit);\r\n  padding: calc(var(--spacing-unit) * 2);\r\n  background: var(--container-bg);\r\n\r\n}\r\n// .min-height-applied {\r\n//   min-height: 50vh;\r\n//   transition: min-height 0.3s ease;\r\n// }\r\n\r\n.expenses-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n  font-size: 0.95rem;\r\n  box-shadow: 0 2px 6px var(--shadow-light);\r\n\r\n  thead {\r\n        background-color: #f1f5f9;\r\n\r\n    th {\r\n      text-align: left;\r\n      padding: 1rem;\r\n      color: #111827;\r\n      // border: 1px solid #ddd;\r\n    }\r\n  }\r\n\r\n  tbody {\r\n    tr {\r\n      transition: background-color 0.2s ease;\r\n\r\n      &:hover {\r\n        background-color: #f9fafb;\r\n      }\r\n\r\n      td {\r\n        padding: 0.9rem 1rem;\r\n        // border: 1px solid #ddd;\r\n      }\r\n\r\n      td:last-child {\r\n        white-space: nowrap;\r\n\r\n        button {\r\n          margin-right: 0.5rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n          background-color: #17a2b8;\r\n          color: white;\r\n\r\n          &:last-child {\r\n            background-color: #dc2626; // red for delete\r\n          }\r\n\r\n          &:hover {\r\n            opacity: 0.9;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.expense-card-main {\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 0.75rem;\r\n  padding: calc(var(--spacing-unit) * 2);\r\n  transition: all 0.2s ease-in-out;\r\n  position: relative;\r\n  .expense-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: start;\r\n    margin-bottom: 0.5rem;\r\n    padding-bottom: var(--spacing-unit);\r\n    border-bottom: 1px solid var(--border-color);\r\n\r\n    .expense-title {\r\n      font-size: 1.1rem;\r\n      font-weight: 700;\r\n      color: var(--text-color-dark);\r\n      margin: 0;\r\n    }\r\n\r\n    .expense-actions {\r\n      display: flex;\r\n      gap: 0.75rem;\r\n\r\n      .action-button {\r\n        // background: none;\r\n        // border: 1px solid var(--border-color);\r\n        // border-radius: 50%;\r\n        // width: 1.8rem;\r\n        // height: 1.8rem;\r\n        // display: flex;\r\n        // align-items: center;\r\n        // justify-content: center;\r\n        // cursor: pointer;\r\n        // transition: all 0.2s ease;\r\n          margin-right: 0.5rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n          &:hover {\r\n            background: var(--container-bg);\r\n            opacity: 0.9;\r\n          }\r\n      }\r\n      \r\n    }\r\n  }\r\n\r\n  .expense-details-grid {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem 1.5rem;\r\n    margin-bottom: calc(var(--spacing-unit) * 1.5);\r\n\r\n    .exp-detail-item {\r\n      display: flex;\r\n      align-items: center;\r\n      font-size: 0.95rem;\r\n      color: var(--text-color-medium);\r\n\r\n      .detail-icon {\r\n        color: var(--primary-color);\r\n        font-size: 1.15rem;\r\n        margin-right: 0.5rem;\r\n      }\r\n\r\n      .detail-label {\r\n        font-weight: 600;\r\n        color: var(--text-color-dark);\r\n        margin-right: 0.25rem;\r\n        width: 100px;\r\n      }\r\n\r\n      .detail-value {\r\n        font-weight: 500;\r\n        color: var(--text-color-dark);\r\n\r\n        &.amount {\r\n          color: var(--accent-color);\r\n          font-weight: 700;\r\n        }\r\n\r\n        &.expense-type-tag {\r\n          background-color: var(--primary-color);\r\n          color: var(--text-color-light);\r\n          padding: 0.2em 0.6em;\r\n          border-radius: 0.25em;\r\n          font-size: 0.85em;\r\n          font-weight: 600;\r\n        }\r\n\r\n        &.expense-court-ref {\r\n          background-color: #f0f0f0;\r\n          color: var(--text-color-dark);\r\n          padding: 0.2em 0.6em;\r\n          border-radius: 0.25em;\r\n          font-size: 0.85em;\r\n          font-weight: 500;\r\n          border: 1px solid #d4d4d4;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .expense-description {\r\n    font-size: 0.9rem;\r\n    color: var(--text-color-medium);\r\n    line-height: 1.6;\r\n    margin-bottom: var(--spacing-unit);\r\n\r\n    p {\r\n      margin: 0;\r\n\r\n      strong {\r\n        color: var(--text-color-dark);\r\n      }\r\n    }\r\n  }\r\n\r\n  .expense-document {\r\n    margin-top: calc(var(--spacing-unit) * 0.5);\r\n\r\n    a {\r\n      color: var(--primary-color);\r\n      text-decoration: none;\r\n      font-size: 0.9rem;\r\n      font-weight: 600;\r\n\r\n      &:hover {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.no-expenses {\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n  color: var(--text-color-medium);\r\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n  background: var(--card-bg);\r\n  border-radius: 0.75rem;\r\n  border: 1px dashed var(--border-color);\r\n  box-shadow: 0 2px 5px var(--shadow-light);\r\n  margin-top: calc(var(--spacing-unit) * 2);\r\n  grid-column: 1/-1;\r\n}\r\n\r\n.error-msg {\r\n  text-align: center;\r\n  font-size: 0.95rem;\r\n  color: var(--danger-color);\r\n  background: #ffecec;\r\n  padding: var(--spacing-unit) calc(var(--spacing-unit) * 1.5);\r\n  border-radius: 0.375rem;\r\n  border: 1px solid #ffccca;\r\n  margin-bottom: var(--spacing-unit);\r\n}\r\n\r\n\r\n.pagination-controls {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 20px 0;\r\n  gap: 10px;\r\n\r\n\r\n  button {\r\n    padding: 6px 12px;\r\n    background: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    min-width: 80px;\r\n    text-align: center;\r\n\r\n\r\n    &:disabled {\r\n      background: var(--primary-color);\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n.pagination-settings {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  padding: 7px 18px;\r\n  background-color: #E2E8F0;\r\n  border-radius: 6px;\r\n\r\n\r\n  label {\r\n    white-space: nowrap;\r\n    color: #1f2937;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n  #expensePerPageSelect {\r\n    border: none;\r\n    border-radius: 6px;\r\n    outline: none;\r\n    padding: 6px 32px 6px 12px;\r\n    background-color: white;\r\n    font-size: 14px;\r\n    color: #333;\r\n    cursor: pointer;\r\n    min-width: 70px;\r\n\r\n\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n\r\n\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 16px;\r\n\r\n\r\n    transition: all 0.2s ease;\r\n    box-shadow: none !important;\r\n\r\n\r\n    &:hover {\r\n      background-color: #fafafa;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n      background-color: white;\r\n    }\r\n\r\n\r\n    option {\r\n      border: none !important;\r\n      outline: none;\r\n      padding: 4px 8px;\r\n    }\r\n  }\r\n}\r\n.no-spinner::-webkit-outer-spin-button,\r\n.no-spinner::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .expense-container {\r\n    padding: var(--spacing-unit);\r\n    gap: var(--spacing-unit);\r\n\r\n    .expense-card-main {\r\n      padding: calc(var(--spacing-unit) * 1.5);\r\n\r\n      .expense-header {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        gap: 0.5rem;\r\n        margin-bottom: var(--spacing-unit);\r\n\r\n        .exp-main-detail {\r\n\r\n\r\n          .expense-courtRef-tag {\r\n            background-color: #f0f0f0;\r\n            color: var(--text-color-medium);\r\n            padding: 0.2em 0.6em;\r\n            border-radius: 0.25em;\r\n            font-size: 0.8em;\r\n            font-weight: 500;\r\n            border: 1px solid #d4d4d4;\r\n            display: inline-block;\r\n          }\r\n\r\n          .expense-title {\r\n            font-size: 1.3rem;\r\n          }\r\n\r\n          .expense-actions {\r\n            align-self: flex-end;\r\n            margin-top: 0.5rem;\r\n          }\r\n        }\r\n\r\n\r\n      }\r\n\r\n      .expense-details-grid {\r\n        grid-template-columns: 1fr;\r\n        gap: 0.5rem;\r\n        margin-bottom: var(--spacing-unit);\r\n      }\r\n\r\n      .expense-description,\r\n      .expense-document {\r\n        font-size: 0.85rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .expense-container {\r\n    padding: calc(var(--spacing-unit) * 0.5);\r\n\r\n    .expense-card-main {\r\n      padding: var(--spacing-unit);\r\n\r\n      .expense-header {\r\n        .exp-main-detail {\r\n          .expense-title {\r\n            font-size: 1.1rem;\r\n          }\r\n        }\r\n\r\n      }\r\n\r\n      .expense-details-grid {\r\n        .exp-detail-item {\r\n          font-size: 0.85rem;\r\n\r\n          .detail-icon {\r\n            font-size: 1rem;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n   .exp-courtRef-tag {\r\n    margin-bottom: 1rem;\r\n            background-color: #f0f0f0;\r\n            color: var(--text-color-medium);\r\n            padding: 0.2em 0.6em;\r\n            border-radius: 0.25em;\r\n            font-size: 0.8em;\r\n            font-weight: 500;\r\n            border: 1px solid #d4d4d4;\r\n            display: inline-block;\r\n          }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
